var render, staticRenderFns
import script from "./remark_form.vue?vue&type=script&lang=js"
export * from "./remark_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e1d22e3')) {
      api.createRecord('2e1d22e3', component.options)
    } else {
      api.reload('2e1d22e3', component.options)
    }
    
  }
}
component.options.__file = "found/views/kms_new/views/finance/financial_auditing/audit_matching/form/remark_form.vue"
export default component.exports